import {createGesture} from '@/http/girl/verification/createGesture.js';
import {createVerificationAttempt} from '@/http/girl/verification/createVerificationAttempt.js';
import {verificationsLast} from '@/http/girl/verification/verificationsLast.js';

export default {createGesture, createVerificationAttempt, verificationsLast};
